export class AssignToRouteDetail {
  stopName: string;
  fullAddress: string;
  shipmentCount: number;
}
